import React, { useImperativeHandle, useState } from "react";
import SelectSearch from "../SelectSearch";

const noop = () => {};
const defaultProps = {
  defaultValue: "",
  selected: -1,
  onChange: noop,
  options: [],
};

// map the options
function map(option) {
  if (typeof option === "string") {
    return { label: option, value: option };
  }
  return option;
}

function InputSelect({
  className = "bg-white border border-1 border-dark-subtle",
  options,
  canCreate,
  createCaption,
  onCreate,
  onChange,
  selected,
  defaultValue,
  dynamic,
  field,
  resetRef,
  clearable = true,
  ...props
}) {
  const [value, setValue] = useState({ label: "", value: "" });
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [focus, setFocus] = useState(false);

  // Map and initialize all options
  const allOptions = React.useMemo(() => options.map(map), [options]);

  React.useEffect(() => {
    setFilteredOptions(allOptions);
  }, [allOptions]);

  // Set default value
  React.useEffect(() => {
    if (defaultValue) {
      setValue(map(defaultValue));
    }
  }, [defaultValue]);

  function change(option) {
    setValue(option);
    onChange(option.value);
  }

  function onSearch(text) {
    if (dynamic) {
      onChange(text);
      return;
    }

    if (!text || text.trim() === "") {
      setFilteredOptions(allOptions);
    } else {
      const searchLower = text.toLowerCase();
      const filtered = allOptions.filter((option) => {
        const label = option.label?.toString().toLowerCase() || "";
        const value = option.value?.toString().toLowerCase() || "";
        return label.includes(searchLower) || value.includes(searchLower);
      });
      setFilteredOptions(filtered);
    }
  }

  function onClickClear() {
    onChange("");
    setValue({ label: "", value: "" });
    setFilteredOptions(allOptions);
  }

  useImperativeHandle(resetRef, () => ({
    onClickClear,
  }));

  return (
    <SelectSearch
      focus
      value={value}
      className={className}
      options={filteredOptions}
      canCreate={canCreate}
      onCreate={onCreate}
      createCaption={createCaption}
      onChange={change}
      onSearch={onSearch}
      onClickClear={onClickClear}
      onFocus={setFocus}
      clearable={clearable}
      {...props}
    />
  );
}

InputSelect.defaultProps = defaultProps;

export default InputSelect;
